export const toggleIdsInSelection = (current: string[], toggled: string[]): string[] => {
  if (toggled.length === 0) return current;

  if (toggled.every(id => current.includes(id))) {
    return current.filter(id => !toggled.includes(id));
  }

  return [...new Set([...current, ...toggled])];
};

export const expandRoomIdsToValveIds = (
  roomIds: string[],
  valves: { id: string; roomId?: string | null }[],
): string[] => [...new Set(roomIds.flatMap(roomId => valves.filter(v => v.roomId === roomId).map(v => v.id)))];
